import * as yup from "yup";

export const validationSchema = yup.object({
    currentLinesOfBusinessPersonal: yup.bool(),
    currentLinesOfBusinessCommercial: yup.bool(),
    currentLinesOfBusinessHome: yup.bool(),
    currentLinesOfBusinessHealth: yup.bool(),
    currentLinesOfBusinessOther: yup.bool(),
    soldLinesOfBusiness: yup.mixed().test("soldLinesOfBusiness", "Please select current line(s) of business being sold", function () {
        return this.parent.currentLinesOfBusinessPersonal ||
            this.parent.currentLinesOfBusinessCommercial ||
            this.parent.currentLinesOfBusinessHome ||
            this.parent.currentLinesOfBusinessHealth ||
            this.parent.currentLinesOfBusinessOther;
    }),
    currentLinesOfBusinessOtherText: yup.string().when("currentLinesOfBusinessOther", {
        is: true,
        then: schema => schema.required("Please enter other line of business being sold")
    }),
    totalEmployees: yup.number()
        .typeError("Please enter total number of employees")
        .required("Please enter total number of employees"),
    unlicensedAgents: yup.number()
        .typeError("Please enter number of unlicensed employees")
        .required("Please enter number of unlicensed employees"),
    personalLinesDirectCarrierAppointments: yup.number()
        .typeError("Please enter number of direct carrier appointments for personal lines")
        .required("Please enter number of direct carrier appointments for personal lines"),
    licensedAgentsPersonalLines: yup.number()
        .typeError("Please enter number of producers selling personal lines")
        .required("Please enter number of producers selling personal lines"),
    commercialLinesDirectCarrierAppointments: yup.number()
        .typeError("Please enter number of direct carrier appointments for commercial lines")
        .required("Please enter number of direct carrier appointments for commercial lines"),
    licensedAgentsCommercialLines: yup.number()
        .typeError("Please enter number of producers selling commercial lines")
        .required("Please enter number of producers selling commercial lines"),
    licensedAgentsCombination: yup.number()
        .typeError("Please enter number of producers selling a combination of personal and commercial lines")
        .required("Please enter number of producers selling a combination of personal and commercial lines"),
    licensedAgentsOtherLines: yup.number()
        .typeError("Please enter number of producers selling other lines of business")
        .required("Please enter number of producers selling other lines of business"),
});